module.exports = __webpack_public_path__ + "img/noimage.d8952bd2.png";